import React, { useMemo, useState } from 'react';
import { Customized, Pie, PieChart, ResponsiveContainer, Sector } from "recharts";

function PieChartLabel(entry: any) {
  const name = entry.payload.payload.name;
  const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill } = entry;
  let textContent = name.split(' ');
  if (textContent.length > 1) {
    const updated = [];
    for (let i = 0; i < textContent.length; i++) {
      if (i < textContent.length-1) {
        const next = textContent[i+1];
        const thisText = textContent[i];
        if (thisText.length + next.length < 12) {
          updated.push(thisText + ' ' + next);
          i++ //double jump
        } else {
          updated.push(textContent[i]);
        }
      } else {
        updated.push(textContent[i]);
      }
    }
    textContent = updated;
  }
  const percentage = Math.round(entry.payload.payload.value / entry.payload.payload.totalDays * 100)
  return <g>
    {textContent.map((text: string, key: number) => <text x={entry.cx} y={entry.cy + (key * 20)} dy={-30} key={key}
                                          textAnchor="middle"
                                          fontWeight={600} fontSize={20}
                                          fontFamily={'"soleil", sans-serif'}>
      {text}
    </text>)}

    <text x={entry.cx-8} y={entry.cy + (textContent.length > 1 ? textContent.length * 10 : -2) + 30} dy={-20}
          textAnchor="middle"
          fontWeight={600} fontSize={32}
          fontFamily={'"soleil", sans-serif'}>
      {percentage}
    </text>

    <text x={entry.cx + 18} y={entry.cy + (textContent.length > 1 ? textContent.length * 10 : -2) + 30} dy={-20}
          textAnchor="middle"
          fontWeight={600} fontSize={20}
          fontFamily={'"soleil", sans-serif'}>
      %
    </text>

    <rect x={entry.cx - 50} y={entry.cy + (textContent.length > 1 ? textContent.length * 10 : -2) + 30}
          width={100}
          height={5}
          rx={4}
          ry={4}
          fill={fill}
          strokeWidth={1} />

    <Sector
      cx={cx}
      cy={cy}
      innerRadius={innerRadius}
      outerRadius={outerRadius}
      startAngle={startAngle}
      endAngle={endAngle}
      fill={fill}
    />
  </g>
}

function CircleBackground(props: any) {
  return (
    <circle className={'chart__background'} cx={props.cx} cy={props.cy} r={180} fill="#fff"/>
  )
}

export function UsersWhereaboutsPieChart(props: Props) {
  const pieData = props.data;
  const [activeIndex, setActiveIndex] = useState(0);

  const orderedPieData = useMemo(() => {
    const office = pieData.find((pd: any) => pd.name === 'In the Office');
    const wfh = pieData.find((pd: any) => pd.name === "Working from home");
    let first: any = undefined;
    if (office) {
      first = office;
    } else if (wfh) {
      first = wfh;
    }

    if (first) {
      const filtered = pieData.filter((pd: any) => pd !== first);
      return [first, ...filtered];
    }
    return pieData;
  }, [pieData]);

  return (
    <>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart width={800} height={800}>
          <Customized
            component={
              <CircleBackground />
            }
          />
          <Pie
            activeShape={PieChartLabel}
            data={orderedPieData}
            cx="50%"
            cy="50%"
            innerRadius={120}
            outerRadius={160}
            fill="#8884d8"
            dataKey="value"
            paddingAngle={2}
            activeIndex={activeIndex}
            onMouseEnter={(data, index) => setActiveIndex(index)}
          />
        </PieChart>
      </ResponsiveContainer>
    </>
  )
}

interface Props {
  data: any;
}
